module.exports = "/_next/static/images/404-feb0385ca1e522d739f0254dfff6ed60.svg";